export default function LinkIconUIKit({ width = 20, height = 20, stroke = 'currentColor', strokeWidth = 1.1 }){
	return (
	<svg width={width} height={height} viewBox="0 0 20 20">
		<path
			fill="none"
			stroke={stroke}
			strokeWidth={strokeWidth}
			d="M10.625,12.375 L7.525,15.475 C6.825,16.175 5.925,16.175 5.225,15.475 L4.525,14.775 C3.825,14.074 3.825,13.175 4.525,12.475 L7.625,9.375"
		/>
		<path
			fill="none"
			stroke={stroke}
			strokeWidth={strokeWidth}
			d="M9.325,7.375 L12.425,4.275 C13.125,3.575 14.025,3.575 14.724,4.275 L15.425,4.975 C16.125,5.675 16.125,6.575 15.425,7.275 L12.325,10.375"
		/>
		<path
			fill="none"
			stroke={stroke}
			strokeWidth={strokeWidth}
			d="M7.925,11.875 L11.925,7.975"
		/>
	</svg>
)};